import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';
import HelpOutline from '@material-ui/icons/HelpOutline';
import {
  Button,
  Checkbox,
  IconButton,
  ThemeProvider
} from '@workboard/wobo-ui';
import { debounce, uniq } from 'lodash';
import React, { createRef } from 'react';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import AddKrTag from '../../../../krTags/components/addkrTag.component';
import GoalServices from '../../../../services/goal.services';
import {
  constructNestedKRPayload,
  reactLoader,
  removeReactLoader
} from '../../../../utils/common.js';
import { eventKeyConstants } from '../../../../utils/eventKey';
import CreateWsPopUp from '../../../CreateWsPopUp.component';
import Customokr from '../../../custom_fields/customobj/Customokr';
import DeleteCommonModal from '../../../deleteCommonModal.component';
import { ErrorTextComp } from '../../../inputs/fields.component';
import KrAlignDependance from './krAlignDependence';
import KrRelationshipWrapper from './krRelationshipWrapper';
import NestedInlineComp from './NestedInline.component';
import { AddFinancialTargetsButton } from '../AddFinancialTargetsButton';
import PermissionComp from './permission.component';
import { isKrDurationChangedFromSaved } from '../../../../utils/krQuarterDuration';

const styles = theme => ({
  root: {
    '& .MuiScopedCssBaseline-root': {
      display: 'inline-block !important'
    },

    '& .MuiButtonBase-root': {
      top: '-20px !important',
      left: '-8px !important',
      width: '30px',
      height: '30px'
    },
  },

  closeIconStyle: {
    '& .MuiSvgIcon-root': {
      height: '1.5rem',
      width: '1.5rem'
    }
  }
})

const StyledCheckbox = styled(Checkbox)`
  .MuiButtonBase-root {
    width: 24px;
    height: 24px;
    margin-left: -5px;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;

const StyledIconButton = styled(IconButton)`
  &:not([id^="deleteOptionBtn"]) {
    width: 16px;
    height: 16px;
    svg {
      width: 14px;
      height: 14px;
    }
  }
  &[id^="deleteOptionBtn"]{
    &:focus {
        color: #687587 !important;
        background-color: transparent !important;
    }
  }
`;

class WorkstreamComp extends React.Component {
  constructor(props) {
    super(props);
    const isKrCoOwnerEnabled = window.wbConfig.isKrCoOwnerEnabled ?? false;
    this.state = {
      filter: {
        Team: [],
        WorkStream: [],
        customWs: []
      },
      achievingWsEn: false,
      achiWSHelpPopUp: false,
      metric:
        this.props.item &&
        this.props.item.metric &&
        this.props.item.metric != undefined
          ? this.props.item.metric
          : 3,
      Exclude:
        this.props.item && this.props.item.progress_consider == 0
          ? true
          : false,
      target:
        this.props.item && this.props.item.target ? this.props.item.target : "",
      ErrorDis: "",
      errors: {},
      _isWsMounted: false,
      teamPermissionSelected:
          this.props.item && this.props.item.permission_teams
            ? this.props.item.permission_teams
            : this.props.goalDetails.type == 1 &&
            this.props.goalDetails.default_permission_teams &&
            Object.keys(this.props.goalDetails.default_permission_teams).length > 0
            ? this.props.goalDetails.default_permission_teams : [],
      bizPermissionSelected:  this.props.item && this.props.item.permission_biz ? this. props.item.permission_biz : [],
      permission: [],
      permissionstate:
          this.props.item && this.props.item.permission
            ? this.props.item.permission.split(",").map(Number)
            : this.props.goalDetails.type == 1 ? (this.props.goalDetails.default_permission &&
              Object.keys(this.props.goalDetails.default_permission).length > 0 ? this.props.goalDetails.default_permission.split(",").map(Number) : [8])  : [10],
      source:
        this.props.item && this.props.item.source ? this.props.item.source : 2,
      krId: this.props.item && this.props.item.id ? this.props.item.id : "",
      subPermissonEn: false,
      _isTeamMounted: false,
      krPermissionText:
        this.props.goalDetails && this.props.goalDetails.permission.length > 0
          ? this.props.goalDetails &&
            this.props.goalDetails.permission.length > 1
            ? "Custom view permissions"
            : "Organization can view"
          : this.props.goalDetails.type == 1
          ? "Only team can view"
          : "Only owner can view",
      wsSelected:
        this.props.item &&
        this.props.item.metricWs !== undefined &&
        this.props.item.metricWs.length > 0
          ? this.props.item.metricWs
          : [],
      wsValueErr: "Search and select a workstream",
      applyObjKr:
        this.props.goalDetails && this.props.goalDetails.all_metrics == 1
          ? true
          : false,
      targetValueErr: "Add target value",
      workstreamSearchVal: "",
      teamSearchVal: "",
      newAddWs: this.props.wsData,
      permissionHelpPopUp: false,
      measureSepWsEn: false,
      measureSepWsSearchEn: false,
      customWsSearchVal: "",
      measureColWsEn:
        this.props.item &&
        this.props.item.metricWsColumn !== undefined &&
        this.props.item.metricWsColumn.length > 0
          ? false
          : true,

      columnWsCount: 0,
      workStreamColSelected:
        this.props.item &&
        this.props.item.metricWsColumn !== undefined &&
        this.props.item.metricWsColumn.length > 0
          ? this.props.item.metricWsColumn
          : [],
      createWsPopUp: false,
      confirmPopup: false,
      krAlingSelected: this.props.item &&
               this.props.item.kr_aligns !== undefined &&
               this.props.item.kr_aligns.length > 0
                ? this.props.item.kr_aligns
                : [],
      krDependenciesSelected: this.props.item &&
                  this.props.item.kr_dependent !== undefined &&
                  this.props.item.kr_dependent.length > 0
                    ? this.props.item.kr_dependent
                    : [],
      tags:[],
      wsListed: this.getWsListed(),
      nplTags:this.props.nplTags ? this.props.nplTags : [],
      selectednlplTags:this.props.selectednlplTags ? this.props.selectednlplTags : [],
      selectednlplTagsName:this.props.selectednlplTagsName ? this.props.selectednlplTagsName : [],
      tagsList:this.props.tagsList ? this.props.tagsList:[],
      limit: 5,
      offset: 5,
      customFiledRequired:false,
      isCustomSave:[],
      isRequirdCustomOkr:[],
      customInputData:[],
      isAnuualQChange:false,
      coOwners: isKrCoOwnerEnabled ? (this.props.item.coOwners && this.props.item.coOwners.length > 0 ? this.props.item.coOwners : (this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [])) : [],
      checkRolFlag: this.props.item?.is_real_owner_rol != undefined ? true : false,
     };

    this.GoalServices = new GoalServices();
    this.onSiteChanged = this.onSiteChanged.bind(this);
    this.saveKr = this.saveKr.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.filterTeamFunctions = this.filterTeamFunctions.bind(this);
    this.setRightPaneValue = this.setRightPaneValue.bind(this);
    this.clickEvent = this.clickEvent.bind(this);
    this.handleExcludeChange = this.handleExcludeChange.bind(this);
    this.closeWsPopUp = this.closeWsPopUp.bind(this);
    this.filterWorkStreamFunction = this.filterWorkStreamFunction.bind(this);
    this.permissionData = this.permissionData.bind(this);
    this.teamPermissionData = this.teamPermissionData.bind(this);
    this.handleWorkStreamChange = this.handleWorkStreamChange.bind(this);
    this.filterCustomWsFunction = this.filterCustomWsFunction.bind(this);
    this.isRequiredCustomOkrFiled = this.isRequiredCustomOkrFiled.bind(this);
    this.isSaveCustom =this.isSaveCustom.bind(this)
    this.renderError = this.renderError.bind(this);
    this.delayedCalleback = debounce(function(event, term) {
      let _this = this;
      if (term == "team") {
        this.setState({ teamSearchVal: event.target.value }, () =>
        _this.filterTeamFunctions(event)
        );
      } else if (term == "workstream") {
        if(event.target.type != "checkbox"){
          this.setState({ workstreamSearchVal: event.target.value }, () =>
          _this.filterWorkStreamFunction(event)
        );}
      } else if (term == "customWorkstrem") {
        this.setState({ customWsSearchVal: event.target.value }, () =>
        _this.filterCustomWsFunction(event)
        );
      }
    }, 300);
    this.CreateNewWs = this.CreateNewWs.bind(this);
    this.changeSearchBox = this.changeSearchBox.bind(this);
    this.exitDeleteModal = this.exitDeleteModal.bind(this);
    this.deleteItems = this.deleteItems.bind(this);
    this.saveItems = this.saveItems.bind(this);
    this.saveAlignArr = this.saveAlignArr.bind(this);
    this.saveDependentArr = this.saveDependentArr.bind(this);
    this.helpPopperHandler = this.helpPopperHandler.bind(this);
    this.handleRemoveWorkstream = this.handleRemoveWorkstream.bind(this);
    this.radioButtonsKeyboardHandler = this.radioButtonsKeyboardHandler.bind(this);
    this.updateTags = this.updateTags.bind(this);
    this.toggleachievingWsEn=this.toggleachievingWsEn.bind(this);
    this.observer = createRef(null);
    this.saveKrCompleted = this.saveKrCompleted.bind(this);
  }

  fetchWorkstream(node){
    let _this = this;
    if (this.observer.current) this.observer.current.disconnect()
    this.observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        if(_this.state.limit === 5 && (!_this.state.workstreamSearchVal ||  _this.state.workstreamSearchVal.length <= 0 )){
          _this.GoalServices.searchWorkStream({
            term: '',
            offset: _this.state.offset,
            limit: _this.state.limit
          }).then(function (response) {
            if (response.data) {
              let responseData =  [..._this.state.filter.WorkStream, ...response.data.data];
              _this.setState({
                filter: {
                  ..._this.state.filter,
                  WorkStream: uniq(responseData,'team_id')
                },
                offset: _this.state.offset + 5,
                limit: response.data.data.length
              });
            }
          });
        }
      }
    })
    if (node) this.observer.current.observe(node)
  }

  fetchWorkstreamProp = this.fetchWorkstream.bind(this);

  changeSearchBox(event, term) {
    event.persist();
    this.delayedCalleback(event, term);
  }
  getWsListed = () => {

    let wsListed = [];

    if(this.props.item && this.props.item.metricWs !== undefined && this.props.item.metricWs.length > 0){

      this.props.item.metricWs.map(team => {



        team.ws.map((ws) => {

          wsListed.push({...ws, mainWS: team});

        })

      })

    }

    wsListed.sort(this.compare );

    return wsListed;

  }



  compare( a, b ) {

    if ( a.listOrder < b.listOrder ){

      return -1;

    }

    else if ( a.listOrder > b.listOrder ){

      return 1;

    }

    return 0;

  }
  componentDidMount() {
    this.props.setSavedAnnualDuration(this.props.item.isQuarter,this.props.item.quarter_name,this.props.item.id)
    this.props.metricRef(this)
    document.addEventListener("mousedown", this.clickEvent, false);
    $(".goalPopupNew").css("overflow", "hidden");
    if (Object.keys(this.state.newAddWs).length > 0) {
      this.state.wsSelected.push(this.state.newAddWs);
      let _this = this;
      setTimeout(function() {
        _this.setState({
          wsSelected: _this.state.wsSelected
        });
      }, 50);
    }
    let _this = this;
    if (_this.state.wsSelected.length > 0) {
      let newArr = _this.state.wsSelected;
      newArr = newArr.map(v => v.ws.filter(s => s.board_type == 2) );
      this.setState({
        columnWsCount: newArr[0].length > 0 ? 1 : 0
      });
    }
  }

  componentWillUnmount() {
    this.props.metricRef(null)
    document.removeEventListener("mousedown", this.clickEvent);
  }

  permissionData(perData) {
    this.setState({
      permissionstate: perData
    });
  }

  teamPermissionData(teamPerData) {
    this.setState({
      teamPermissionSelected: teamPerData
    });
  }

  bizPermissionData = (bizPerData) => {
    this.setState({
      bizPermissionSelected: bizPerData
    });
  }

  updateTags(Newtags){
    this.setState({
      selectednlplTagsName: Newtags
    })
  }

  radioButtonsKeyboardHandler(e, id) {
    if (e.key === eventKeyConstants.ARROWUP || e.key === eventKeyConstants.ARROWLEFT) {
      e.preventDefault();

      if (id === 3) {
        this.setState({
          metric: 4
        }, () => {
          document.getElementById('radio-average').focus();
        })
      } else if (id === 1) {
        this.setState({
          metric: 3
        }, () => {
          document.getElementById('radio-percentage').focus();
        })
      } else if (id === 4) {
        this.setState({
          metric: 1
        }, () => {
          document.getElementById('radio-total').focus();
        })
      }
    } else if (e.key === eventKeyConstants.ARROWDOWN || e.key === eventKeyConstants.ARROWRIGHT) {
      e.preventDefault();

      if (id === 1) {
        this.setState({
          metric: 4
        }, () => {
          document.getElementById('radio-average').focus();
        })
      } else if (id === 4) {
        this.setState({
          metric: 3
        }, () => {
          document.getElementById('radio-percentage').focus();
        })
      } else if (id === 3) {
        this.setState({
          metric: 1
        }, () => {
          document.getElementById('radio-total').focus();
        })
      }
    }
  }

  onSiteChanged(e, id) {
    this.setState({
      metric: id,
      showTargetErr: false
    });
  }

  handleExcludeChange() {
    this.setState({
      Exclude: !this.state.Exclude
    });
  }
  renderError(field) {
    return (
      <ErrorTextComp key={field} errors={this.state.errors} field={field} />
    );
  }
  clickEvent(e) {
    let that = this;
    if (
      !$(".objectiveAchi").is(e.target) &&
      $(".objectiveAchi").has(e.target).length === 0
    ) {
      if (this.state.achievingWsEn) {
        that.setState({
          achievingWsEn: false,
          filter: {
            ...that.state.filter,
            WorkStream: []
          }
        });
      }
    }

    if (
      !$(".wsColumnsSearch").is(e.target) &&
      $(".wsColumnsSearch").has(e.target).length === 0
    ) {
      if (this.state.measureSepWsEn) {
        that.setState({
          measureSepWsEn: false,
          filter: {
            ...that.state.filter,
            customWs: []
          }
        });
      }
    }
  }

  handleChange(e) {
    const pattern = /^(\.)?[0-9]+(\.\d{0,10})?$/;
    let name = e.target.name;
    let value = e.target.value;
    const state = this.state;
    if (value === "" || pattern.test(value)) {
      state[name] = value;
      this.setState(state);
    }
    this.setState({
      errors: {}
    });
  }

  handleOwnerSelect(val) {
    this.setState({
      ownerText: val.fullName,
      owner: val.userId,
      krOwnerEn: false,
      krOwnerPic: val.picture
    });
  }

  filterTeamFunctions(event) {
    event.preventDefault();
    let input, filter;
    let _this = this;
    input = document.getElementById("TeamSearch");
    filter = input.value.toLowerCase();
    filter[0] === " " ? filter[0].replace(" ", "") : filter;
    filter[filter.length - 1] === " "
      ? filter[filter.length - 1].replace(" ", "")
      : filter;
    if (filter.length > 1) {
      this.GoalServices.searchTeamName({ term: filter }).then(function(
        response
      ) {
        if (response.data) {
          _this.setState({
            filter: {
              ..._this.state.filter,
              Team:
                _this.state.teamSearchVal &&
                _this.state.teamSearchVal.length > 1
                  ? response.data
                  : []
            }
          });
        }
      });
    } else {
      _this.setState({
        filter: {
          ..._this.state.filter,
          Team: []
        }
      });
    }
  }

  selectTeam(event, valTeam) {
    let _this = this;
    _this.setState({
      teamSearchText: valTeam.name,
      for_0: valTeam.id,
      subPermissonEn: false
    });
  }

  setRightPaneValue() {
    if(this.props.goBackFromMitNestedKr){
      this.props.goBackFromMitNestedKr();
    }else{
      this.props.closeKrRightPane(false,this.state.krId);
    }
  }

  filterWorkStreamFunction(event) {
    event.preventDefault();
    event.stopPropagation();
    let _this = this;
    const { workstreamSearchVal = '' } = this.state;
    const inputValue = workstreamSearchVal.trim();
    if (inputValue.length > -1) {
      this.GoalServices.searchWorkStream({ term: inputValue}).then(function(
        response
      ) {
        if (response.data) {
          const responseData = response.data.data || [];
          _this.setState({
            filter: {
              WorkStream:responseData,
            },
            limit: responseData.length
          });

          if (
            responseData.length > 0 &&
            inputValue.length > 1
          ) {
            $('.krRightPaneContent').parent().animate({ scrollTop: 200 });
          }
        }
      });
    } else {
      _this.setState({
        filter: {
          ..._this.state.filter,
          WorkStream: []
        }
      });
    }
  }

  filterCustomWsFunction(event) {
    let newColuArr = this.state.columnWsCount;
    let newColuArrs = this.state.wsSelected;
    let wsColIds = [];

    if (newColuArr.length > 0) {
      newColuArr = newColuArr;
    } else {
      newColuArrs.map(eachMainWS =>
        eachMainWS.ws.filter(eachWS => eachWS.board_type == 2)
      );
      newColuArr = newColuArrs;
    }
    newColuArr.map(eachMainWS =>
      eachMainWS.ws.map(eachWS => wsColIds.push(eachWS.id))
    );
    let tags = wsColIds.join(",");
    event.preventDefault();
    event.stopPropagation();
    let input, filter;
    let _this = this;
    input = document.getElementById("CustomWorkStream");
    filter = input.value.toLowerCase();
    filter[0] === " " ? filter[0].replace(" ", "") : filter;
    filter[filter.length - 1] === " "
      ? filter[filter.length - 1].replace(" ", "")
      : filter;

    if (filter.length > 1) {
      this.GoalServices.searchWorkStreamColumns({
        term: filter,
        wsIds: tags
      }).then(function(response) {
        if (response.data) {
          _this.setState({
            filter: {
              customWs:
                _this.state.customWsSearchVal &&
                _this.state.customWsSearchVal.length > 1
                  ? response.data
                  : []
            }
          });

          if (
            response.data.length > 0 &&
            _this.state.customWsSearchVal.length > 1
          ) {
            $('.krRightPaneContent').parent().animate({ scrollTop: 400 });
          }
        }
      });
    } else {
      _this.setState({
        filter: {
          ..._this.state.filter,
          customWs: []
        }
      });
    }
  }

  getCustomWsFunction(event) {
    let newColuArr = this.state.columnWsCount;
    let newColuArrs = this.state.wsSelected;
    let wsColIds = [];

    if (newColuArr.length > 0) {
      newColuArr = newColuArr;
    } else {
      newColuArrs.map(eachMainWS =>
        eachMainWS.ws.filter(eachWS => eachWS.board_type == 2)
      );
      newColuArr = newColuArrs;
    }
    newColuArr.map(eachMainWS =>
      eachMainWS.ws.map(eachWS => wsColIds.push(eachWS.id))
    );
    let tags = wsColIds.join(",");
    event.preventDefault();
    event.stopPropagation();
    let input, filter;
    let _this = this;
    this.GoalServices.searchWorkStreamColumns({ term: "", wsIds: tags }).then(
      function(response) {
        if (response.data) {
          _this.setState({
            filter: {
              customWs: response.data
            },
            measureSepWsEn: !_this.state.measureSepWsEn
          });

          if (response.data.length > 0) {
            $('.krRightPaneContent').parent().animate({ scrollTop: 400 });
          }
        }
      }
    );
  }

  handleWorkStreamColChange(event, mainWS, subWS) {
    event.stopPropagation();
    let existingState = this.state.workStreamColSelected;
    let mainWSTeam = existingState.find(val =>
      mainWS.id ? val.id == mainWS.id : val.ws_name == mainWS.ws_name
    );
    let result = [];
    if (mainWSTeam) {
      if (mainWSTeam.col.find(subWork => subWork.id == subWS.id)) {
        if (mainWSTeam.col.length > 1) {
          let filter = mainWSTeam.col.filter(
            eachSubWork => eachSubWork.id != subWS.id
          );
          result = [
            ...existingState.filter(mainTeam =>
              mainWS.id
                ? mainTeam.id != mainWS.id
                : mainTeam.ws_name != mainWS.ws_name
            ),
            {
              ...mainWSTeam,
              col: filter
            }
          ];
        } else {
          result = [
            ...existingState.filter(mainTeam =>
              mainWS.id
                ? mainTeam.id != mainWS.id
                : mainTeam.ws_name != mainWS.ws_name
            )
          ];
        }
      } else {
        mainWSTeam.col.push(subWS);

        result = [
          ...existingState.filter(mainTeam => {
            if (mainWSTeam.id) {
              return mainTeam.id != mainWSTeam.id;
            } else {
              return mainTeam.ws_name != mainWSTeam.ws_name;
            }
          }),
          mainWSTeam
        ];
      }
    } else {
      let filter = mainWS.col.filter(eachWS => eachWS.id == subWS.id);
      result = [
        ...existingState,
        {
          ...mainWS,
          col: filter
        }
      ];
    }
    this.setState({
      workStreamColSelected: result
    });
  }

  helpPopperHandler(e) {
    if (e.type === "click" || e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      this.setState(prevState => ({
        achiWsHelpPopUp: !prevState.achiWsHelpPopUp
      }));
    } else if (e.key === "Escape" || e.key === "Tab" || (e.shiftKey && e.key === "Tab")) {
      e.stopPropagation();
      this.setState({ achiWsHelpPopUp: false })
    }
  }

  handleRemoveWorkstream () {
    const focusableRemoveElements = document.querySelectorAll(
      '[id^="deleteOptionBtn"]'
    )
    const focusableRemoveArr = Array.prototype.slice.call(focusableRemoveElements);
    const firstRemoveBtn = focusableRemoveArr[0];
    if (firstRemoveBtn) {
      firstRemoveBtn?.focus();
    } else {
      const isTabbing = document.body.classList.contains('is-tabbing');
      if (isTabbing) this.setState({ achievingWsEn: true })
    }
  }

  handleWorkStreamChange(event, mainWS, subWS) {
    event.stopPropagation();

    let wsListed = [...this.state.wsListed], exists = false;

    if(wsListed.find(item => subWS.id == item.id)){

      exists = true;

    }

    if(!exists){

      subWS['listOrder'] = wsListed.length ? (wsListed[wsListed.length - 1]['listOrder'] + 1) : 1;
      wsListed.push({...subWS, mainWS});

    } else {

      let filter = wsListed.filter(
        eachSubWork => eachSubWork.id != subWS.id
      );
      wsListed = filter;
    }

    let existingState = this.state.wsSelected;
    let mainWSTeam = existingState.find(val =>
      mainWS.team_id
        ? val.team_id == mainWS.team_id
        : val.team_name == mainWS.team_name
    );
    let result = [];
    if (mainWSTeam) {
      if (mainWSTeam.ws.find(subWork => subWork.id == subWS.id)) {
        if (mainWSTeam.ws.length > 1) {
          let filter = mainWSTeam.ws.filter(
            eachSubWork => eachSubWork.id != subWS.id
          );
          result = [
            ...existingState.filter(mainTeam =>
              mainWS.team_id
                ? mainTeam.team_id != mainWS.team_id
                : mainTeam.team_name != mainWS.team_name
            ),
            {
              ...mainWSTeam,
              ws: filter
            }
          ];
        } else {
          result = [
            ...existingState.filter(mainTeam =>
              mainWS.team_id
                ? mainTeam.team_id != mainWS.team_id
                : mainTeam.team_name != mainWS.team_name
            )
          ];
        }
      } else {
        mainWSTeam.ws.push(subWS);

        result = [
          ...existingState.filter(mainTeam => {
            if (mainWSTeam.team_id) {
              return mainTeam.team_id != mainWSTeam.team_id;
            } else {
              return mainTeam.team_name != mainWSTeam.team_name;
            }
          }),
          mainWSTeam
        ];
      }
    } else {
      let filter = mainWS.ws.filter(eachWS => eachWS.id == subWS.id);
      result = [
        ...existingState,
        {
          ...mainWS,
          ws: filter
        }
      ];
    }
    let newArr = result;
    let cusWsCount = 0;
    newArr.map(eachMainWS => {
      let my_filter = eachMainWS.ws.filter(eachWS => eachWS.board_type == 2);
      if (my_filter.length > 0) {
        cusWsCount = 1;
      }
    });
    this.setState({
      wsSelected: result,
      wsListed: wsListed,
      columnWsCount: cusWsCount,
      measureColWsEn: result.length > 0 ? true : false,
      measureSepWsSearchEn:
        result.length > 0 ? this.state.measureSepWsSearchEn : false
    }, () => {
      this.handleRemoveWorkstream(event, mainWS, subWS);
    });
  }

  closeWsPopUp(MainWS) {
    let _this = this;
    if (MainWS != undefined) {
      MainWS = Object.assign({},MainWS);
      _this.state.wsSelected.push(MainWS);
      const selectWS = {};
      if(typeof MainWS != 'undefined' && MainWS){
        selectWS.board_type = MainWS.ws[0].board_type;
        selectWS.id = MainWS.ws[0].id;
        selectWS.id = MainWS.ws[0].id;
        selectWS.name = MainWS.ws[0].name;
        selectWS.mainWS = MainWS;
      }
      _this.state.wsListed.push(selectWS);
      if (_this.state.wsSelected.length > 0) {
        let newArr = _this.state.wsSelected;
        const customWsArray = newArr.map(eachMainWS =>
          eachMainWS.ws.filter(eachWS => eachWS.board_type == 2)
        );
        let nonEmptyVals = customWsArray.filter(item => item.length > 0)

        setTimeout(function() {
          _this.setState({
            columnWsCount: nonEmptyVals.length
          });
        }, 50);
      }

      _this.setState({
        wsSelected: _this.state.wsSelected,
        createWsPopUp: false
      });
    } else {
      _this.setState({
        createWsPopUp: false
      });
    }
  }

  CreateNewWs() {
    this.setState({
      wsSelected: this.state.wsSelected,
      createWsPopUp: !this.state.createWsPopUp
    });
  }

  saveKrCompleted(callback = null, data = {}) {
    if (!this.props.mitChildKr) {
      window.dispatchEvent(new CustomEvent('krDataRefresh'));
    }
    if (callback && typeof callback === 'function') {
      callback(data);
    } else {
      this.props.closeKrRightPane(true);
    }
  }

  saveKr(callback = null) {
    const { t } = this.props
    let errors = {};
    let kr_duration=this.props.kr_duration;
    let isQuarter= this.props.isQuarter;
    this.isSaveCustom(this.state.customInputData)
    this.setState({isCustomSave:[]})
    let metricNote = this.props.krNote;
    if (this.state.wsSelected.length < 1) {
      errors["showWsErr"] = true;
      document.getElementById("find-existing-workstream").focus();
      setTimeout(()=>{
        let elem = document.getElementById("WorkStream");
        elem.setAttribute("aria-invalid", "true");
      })
    }

    if (this.state.metric == 4) {
      if (this.state.target === "") {
        errors["showTargetErr"] = true;
      }
      if (parseFloat(this.state.target) == 0) {
        errors["showTargetErr"] = true;
        this.setState({
          targetValueErr: t("Please add greater than zero")
        });
      }
    }
    if( this.state.isRequirdCustomOkr.length>0){
      errors["customokr"] = `Please enter required field`;
      this.setState({isCustomSave:this.state.isRequirdCustomOkr})

    }

    // Validate realOwner using role flags or ownerList
    if (this.props.realOwner && this.props.realOwner.id) {
      if (this.state.checkRolFlag) {
        if (this.props.item && this.props.item.is_real_owner_rol !== undefined && this.props.item.is_real_owner_rol) {
          errors['real_owner_validation'] = `${this.props.realOwner.name} has Read Only access and can't be assigned KRs`;
          this.props.showRolErr(true);
          this.setState({ checkRolFlag: false });
        } else {
          this.props.showRolErr(false);
        }
      } else {
        this.props.showRolErr(false);
      }
    }

    let krText = this.props.krText;
    let isError = false;
    if (krText == "") {
      isError = true;
      this.props.showMetricNameErr();
      let elem = document.getElementById("metric-name-text");
      elem.setAttribute("aria-invalid", "true");
      setTimeout(() => {
        document.getElementById("metric-name-text").focus();
      });
      return false;
    }

    if (Object.keys(errors).length) {
      this.setState({ errors });
      if (errors.metricName) {
        $('.krRightPaneContent').parent().animate({ scrollTop: 0 });
      }
       if(errors.customokr&&errors.customokr.length>0){
        setTimeout(() => {
          this.setState({customFiledRequired:true})
          document.querySelector('#cutomobj').scrollIntoView({
            behavior: 'smooth',
          })
        }, 200)}
    } else {
      if (this.props.lastType != this.props.krType && this.props.addEditFlag) {
        this.setState({
          confirmPopup: true
        });
      }
      else if (isKrDurationChangedFromSaved(this.props.item, this.props.kr_duration, this.props.goalDetails)) {
        this.setState({
          confirmPopup: true,
          isAnuualQChange:true,
        })
      }

      else {
        let params = {};
        // full list of WS associated to KR
        let dependentWsSel = this.state.wsSelected;
        let dependentWs = [];
        let dependentWsSelFiltered = [];
        if (Object.keys(dependentWsSel).length > 0) {
          // this.state.wsListed, current WS selected in UI (the list we want to keep)
          dependentWs = this.state.wsListed.map((item) => item.id );
          // new selected list of WS data in format needed to display in edit UI
          /*
          format this.state.wsListed =[
            {
                "list_order": "1",
                "name": "OKR-6870",
                "teamName": "lemons",
                "ws_col_ids": "5471",
                "board_type": "2",
                "id": "1033864",
                "mainWS": {
                    "team_name": "lemons",  <-- need to extract this
                    "ws": [ <-- need to filter based on selection
                        {
                            "list_order": "1",
                            "name": "OKR-6870",
                            "teamName": "lemons",
                            "ws_col_ids": "5471",
                            "board_type": "2",
                            "id": "1033864"
                        },
                        {
                            "list_order": "1",
                            "name": "not selected",
                            "teamName": "lemons",
                            "ws_col_ids": "9999",
                            "board_type": "2",
                            "id": "123456"
                        }
                    ]
                }
            },
            ... more team WS ...
          ]

          format dependentWsSel = [
            {
              "team_name": "lemons",
              "ws": [
                {
                  "list_order": "1",
                  "name": "OKR-6870",
                  "teamName": "lemons",
                  "ws_col_ids": "5471",
                  "board_type": "2",
                  "id": "1033864"
                }
              ]
            },
            ... more WS ...
        ]
        */
          dependentWsSelFiltered = this.state.wsListed.map((item) => {
            // the item is grouped by team.  Ensure we selected a WS from this team
            const workstreams = item.mainWS?.ws?.length ? item.mainWS.ws.filter((ws) => dependentWs.includes(ws.id)) : [];
            if (workstreams.length) {
              return {
                ...item.mainWS,
                ws: workstreams
              };
            }
          });
        }



        let krAlignSel = this.state.krAlingSelected;
        let dependentKrsSel = this.state.krDependenciesSelected;
        let krAligns = [];
        let dependentKrs = [];

        if (Object.keys(krAlignSel).length > 0) {
          krAlignSel.map(item => {
            krAligns.push(item.id);
          });
        }

        if (Object.keys(dependentKrsSel).length > 0) {
          dependentKrsSel.map(item => {
            dependentKrs.push(item.id);
          });
        }
        params.krAligns = krAligns;
        params.dependentKr = dependentKrs;
        params.source = 2;
        let nlpIds =this.state.selectednlplTagsName && this.state.selectednlplTagsName.length ? this.state.selectednlplTagsName : ['']
        let tagids=this.state.tags.length ? this.state.tags : ['']
        let finalTagsIds = [...nlpIds,...tagids]
        params.krTagIds = finalTagsIds;
        params.real_owner = this.props.realOwner.id;
        let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
        params.coOwners = coOwners.length > 0 ? Array.prototype.map
          .call(coOwners, s => s.id)
          .toString() : '';
        params.name = krText;
        params.kr_duration=kr_duration;
        params.isQuarter=isQuarter;
        params.description = metricNote;
        params.metricWs = dependentWs;
        params.target = this.state.target || 0;
        params.metric = this.state.metric;
        params.progress_consider = this.state.Exclude ? 0 : 1;
        params.customField = JSON.stringify(this.props.customFieldsData);
        let teaMperArr = [], bizPerArr = [];
        if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
          const { permission_teams = [], permission_biz = []} = this.props.goalDetails;
          if (Array.isArray(permission_teams) && permission_teams.length) {
            teaMperArr = permission_teams.map(val => val.id);
          }
          if (Array.isArray(permission_biz) && permission_biz.length) {
            bizPerArr = permission_biz.map(val => val.id);
          }
        } else {
          teaMperArr = this.state.teamPermissionSelected.map(val => val.id);
          if(this.state.bizPermissionSelected){
            bizPerArr = this.state.bizPermissionSelected.map(val => val.id);
          }
        }
        params.permission_teams = teaMperArr;
        params.permission_biz = bizPerArr;
        if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
          params.permission = this.props.goalDetails.permission;
        } else {
          params.permission = Array.prototype.map
            .call(this.state.permissionstate, s => s)
            .toString();
        }

        let goalId = this.props.goalDetails.id;
        if (this.props.item && this.props.item.id) {
          params.id = this.props.item.id;
        }
        let columnWsSel = this.state.workStreamColSelected;
        params["nested_krs"] = constructNestedKRPayload(this.props);
        let ColWsArr = {};
        if (Object.keys(columnWsSel).length > 0) {
          columnWsSel.map(item => {
            let ColtWs = [];
            if (item.col) {
              item.col.filter(item1 => {
                ColtWs.push(item1.id);
                ColWsArr[item.id] = ColtWs.join(",");
              });
            }
          });
        }
        params.metricWsColumn = ColWsArr;
        let { actions } = this.props;
        if(this.props.isChildKr && this.props.fromParentKr){
          //params.ownerName = this.state.data_provider.name;
          params.duration = this.props.childKrDuration;
          params.metricWs = dependentWsSelFiltered;
          params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
          params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
          if(this.props.item.parent){
            // params.start_date = this.props.childKrDuration.start ;
            // params.end_date = this.props.childKrDuration.end;
            params.parent = this.props.item.parent;
          }
          //params.duration = this.state.data_provider.name;
          params.coOwnersDetails = coOwners?.length > 0 ? coOwners : [];
          this.props.saveNestedKr(params, this.props.nestedKrIndex, this.props.nestedKrAction);
        } else if(this.props.mitChildKr){
          params.duration = this.props.childKrDuration;
          // we have to keep the more detailed version of the WS object so the child can be
          // edited again without crashing.
          params.metricWs = dependentWsSelFiltered;
          params.metricWsColumn = columnWsSel;
          params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
          params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
          params.target = "";
          this.props.saveQuarterlyKR(params, this.props.mitIndex);
          this.saveKrCompleted(callback, params)
          // this.props.closeKrRightPane();
        } else{
          if(this.props.item.parent){
            params.start_date = this.props.childKrDuration.start ;
            params.end_date = this.props.childKrDuration.end;
            params.parent = this.props.item.parent;
          }
          reactLoader(true);
          this.GoalServices.addEditKr({ goalId: goalId, metric: params }).then(
            response => {
              removeReactLoader();
              if (response.data) {
                if (!this.props.onlyMetEdit) {
                  let result = response.data.data;
                  let krWeightage = null;
                  if (result.krWeightage) {
                    krWeightage = result.krWeightage;
                    delete result["krWeightage"];
                  }
                  result = {
                    clusterItems: this.props.clusterData,
                    clusterCount: this.props.clusterData.length,
                    ...result
                  };
                  if(result.parent){
                    actions.addUpdateNestedKr(result)
                  }else{
                    if (this.state.krId != "") {
                      actions.editNewKr(this.state.krId, result);
                    } else {
                      actions.addNewKr(result);
                    }
                  }

                  if (krWeightage) {
                    this.props.MetricChangeWeight(krWeightage);
                  }
                }
                this.saveKrCompleted(callback, response.data.data);
                // this.props.closeKrRightPane(true);
                // this.GoalServices.triggerGoalMetricDetails({ goalId });
              }
            }
          );
        }
      }
    }
  }


  exitDeleteModal() {
    this.setState({ confirmPopup: false });
  }

  deleteItems() {
    return this.saveItems(false);
  }

  saveItems(retainUpdates = true) {
    let metricNote = this.props.krNote;
    let krText = this.props.krText;
    let kr_duration=this.props.kr_duration;
    let params = {};
    let dependentWsSel = this.state.wsSelected;
    let dependentWs = [];
    if (Object.keys(dependentWsSel).length > 0) {
      dependentWsSel.map(item => {
        if (item.ws) {
          item.ws.map(item1 => {
            dependentWs.push(item1.id);
          });
        }
      });
    }

    if (!retainUpdates) {
      params.retainUpdates = 1;
    }
    params.source = 2;
    params.real_owner = this.props.realOwner.id;
    let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
    params.coOwners = coOwners.length > 0 ? Array.prototype.map
      .call(coOwners, s => s.id)
      .toString() : '';
    params.name = krText;
    params.description = metricNote;
    params.kr_duration=kr_duration;
    params.isQuarter=this.props.isQuarter;
    params.isPeriodChange=this.state.isAnuualQChange
    params.metricWs = dependentWs;
    params.target = this.state.target || 0;
    params.metric = this.state.metric;
    params.progress_consider = this.state.Exclude ? 0 : 1;
    let teaMperArr = [], bizPerArr = [];
    if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
      const { permission_teams = [], permission_biz = []} = this.props.goalDetails;
      if (Array.isArray(permission_teams) && permission_teams.length) {
        teaMperArr = permission_teams.map(val => val.id);
      }
      if (Array.isArray(permission_biz) && permission_biz.length) {
        bizPerArr = permission_biz.map(val => val.id);
      }
    } else {
      teaMperArr = this.state.teamPermissionSelected.map(val => val.id);
      if(this.state.bizPermissionSelected){
        bizPerArr = this.state.bizPermissionSelected.map(val => val.id);
      }
    }
    params.permission_teams = teaMperArr;
    params.permission_biz =  bizPerArr;

    if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
      params.permission = this.props.goalDetails.permission;
    } else {
      params.permission = Array.prototype.map
        .call(this.state.permissionstate, s => s)
        .toString(); // "A,B,C";
    }

    params.customField = JSON.stringify(this.props.customFieldsData);
    let goalId = this.props.goalDetails.id;
    if (this.props.item && this.props.item.id) {
      params.id = this.props.item.id;
    }
    let columnWsSel = this.state.workStreamColSelected;

    let ColWsArr = {};
    if (Object.keys(columnWsSel).length > 0) {
      columnWsSel.map(item => {
        let ColtWs = [];
        if (item.col) {
          item.col.filter(item1 => {
            ColtWs.push(item1.id);
            ColWsArr[item.id] = ColtWs.join(",");
          });
        }
      });
    }
    params["nested_krs"] = constructNestedKRPayload(this.props);
    params.metricWsColumn = ColWsArr;
    let { actions } = this.props;
    if(this.props.isChildKr && this.props.fromParentKr){
      //params.ownerName = this.state.data_provider.name;
      params.duration = this.props.childKrDuration;
      params.metricWs = this.state.wsSelected;
      params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
      params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
      if(this.props.item.parent){
        // params.start_date = this.props.childKrDuration.start ;
        // params.end_date = this.props.childKrDuration.end;
        params.parent = this.props.item.parent;
      }
      //params.duration = this.state.data_provider.name;
      params.coOwnersDetails = coOwners?.length > 0 ? coOwners : [];
      this.props.saveNestedKr(params, this.props.nestedKrIndex, this.props.nestedKrAction);
    } else if(this.props.mitChildKr){
      params.duration = this.props.childKrDuration;
      params.metricWs = this.state.wsSelected;
      params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
      params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
      params.owner = params.real_owner;
      params.target = "";
      this.props.saveQuarterlyKR(params, this.props.mitIndex);
      this.props.closeKrRightPane();
    } else{
      if(this.props.item.parent){
        params.start_date = this.props.childKrDuration.start ;
        params.end_date = this.props.childKrDuration.end;
        params.parent = this.props.item.parent;
      }
      reactLoader(true);
      this.GoalServices.addEditKr({ goalId: goalId, metric: params }).then(
        response => {
          removeReactLoader();
          if (response.data) {
            this.setState({ confirmPopup: false,isAnuualQChange:false });
            if (!this.props.onlyMetEdit) {
              let result = response.data.data;
              let krWeightage = null;
              if (result.krWeightage) {
                krWeightage = result.krWeightage;
                delete result["krWeightage"];
              }
              result = {
                clusterItems: this.props.clusterData,
                clusterCount: this.props.clusterData.length,
                ...result
              };
              if(result.parent){
                actions.addUpdateNestedKr(result)
              }else{
                if (this.state.krId != "") {
                  actions.editNewKr(this.state.krId, result);
                } else {
                  actions.addNewKr(result);
                }
              }
              if (krWeightage) {
                this.props.MetricChangeWeight(krWeightage);
              }
            }
            this.props.closeKrRightPane(true);
            // this.GoalServices.triggerGoalMetricDetails({ goalId });
          }
        }
      );
    }
  }

  saveAlignArr(alignData){
    this.setState({
      krAlingSelected: alignData
    })
  }
  saveDependentArr(dependentData){
    this.setState({
      krDependenciesSelected: dependentData
    })
  }
  saveTag = (childData) =>{
    this.setState({tags:childData})
}
isSaveCustom(isVal){
  let arr=[];
  let j=0;
  let keyArrCategory=[]
  let valArray = []
  isVal && Object.keys(isVal).forEach((v)=>{
    j++;
    isVal[v]["customFields"]&&
    Object.keys(isVal[v]["customFields"]).forEach(objv=>{
      keyArrCategory.push(objv)
      if(isVal[v]["customFields"][objv]['is_required']=='1'
      &&( isVal[v]["customFields"][objv]["text"]  ==undefined || isVal[v]["customFields"][objv]["text"]  ==[])
      ){
           arr.push(objv,v)
          }
      if(isVal[v]["customFields"][objv]["text"]){
        valArray.push(isVal[v]["customFields"][objv]["text"])
      }else{
        valArray.push('')
          }
    })
    if(j==Object.keys(isVal).length){
      this.setState({isRequirdCustomOkr:[...arr]})
    }
    let finalDataArray=[]
    for(let i=0;i<valArray.length;i++){
      if(Array.isArray(valArray[i])){
        valArray[i].forEach(val => {
          finalDataArray.push({id:keyArrCategory[i],val:val.name,object_type:'6'})
        })
      }
      else{
        finalDataArray.push({id:keyArrCategory[i],val:valArray[i],object_type:'6'})
      }

    }
    const tempData=finalDataArray
  })

}


  isRequiredCustomOkrFiled(isVal,id){
    let cust_id=this.state.isCustomSave.find((u) => u == id);
    let ar=this.state.isCustomSave ? this.state.isCustomSave:'';
    let fr= ar.filter(
        (u) => u != cust_id
      )
    this.setState({isCustomSave:fr})
    this.isSaveCustom(isVal)
    this.setState({customInputData:isVal})
  }
handleKeyPress = (event) =>{
  if(event.key == 'Enter'){
    event.preventDefault();
    event.stopPropagation();
  } else if ((event.shiftKey && event.key === "Tab")) {
    event.preventDefault();
    this.setState({ achievingWsEn: false });
    document.querySelector('.measurementTypeBtn').focus();
  } else if (event.key === "Tab") {
    event.preventDefault();
    this.setState({ achievingWsEn: false });
    document.querySelector('.createWsBtn').focus();
  }
}
  toggleachievingWsEn = ()=>{
    this.setState({ achievingWsEn: true });
  }
  render() {
    let errors = this.state.errors;
    let isErrors = Object.keys(errors).length;
    let borderRadius =
      typeof errors["showWsErr"] !== "undefined" ? "  errBorder " : "  ";

    if (this.state.wsSelected.length > 0) {
      errors["showWsErr"] = undefined;
    }
    const {enableModules={}} = this.props.goalDetails || {};
    const executeModule = enableModules.executeModule || false;
    const { t, classes } = this.props;
    return (
      <form className="workstream-form">
        <div className="root-workstream">
          <div className="aEObjectiveAchi">
            <div className="ObjectiveAchiText">
              {t('Find existing workstream')}(s):{" "}
              <span className="text-style-1">*</span>
            </div>
          </div>
          <div className={"objectiveAchi inLineBlk wsAchi " + borderRadius}
              tabIndex={0}
              onFocus={this.toggleachievingWsEn}
              id="find-existing-workstream"
              onClick={event => {
                this.setState({ limit : 5, offset : 5 });
                this.changeSearchBox(event, "workstream")
              }}
              >
            <div
              className="objAchievSearchdiv  "
              onClick={event => {
                this.setState({ achievingWsEn: !this.state.achievingWsEn });
              }}
            >
              {t('Search for a team or workstream')}
            </div>
            {this.state.achievingWsEn && (
              <div id="myAlign" data-testid="myAlign" className="dropdown-alignment ">
                <input
                  type="text"
                  id="WorkStream"
                  placeholder={t("Search for a team or workstream")}
                  className="objAchievSearch"
                  onChange={event => this.changeSearchBox(event, "workstream")}
                  autoFocus={true}
                  autoComplete="off"
                  onKeyDown={(e) => this.handleKeyPress(e)}
                  aria-invalid="false"
                />
                <div className="workstreamList">
                  {this.state.filter.WorkStream &&
                    this.state.filter.WorkStream.map((eachMainWS,index) => (
                      <div {...(this.state.filter.WorkStream.length === index + 1 ? {ref : this.fetchWorkstreamProp} : {})}>
                        {eachMainWS.team_name != null && (
                          <div
                            className="workStreamTitle truncate"
                            key={`WS${eachMainWS.team_name}`}
                          >
                            {eachMainWS.team_name}
                          </div>
                        )}

                        {eachMainWS.ws != null &&
                          eachMainWS.ws &&
                          eachMainWS.ws.map(eachWS => (
                            <div className="myAlign" data-testid="myAlign">
                              <input
                              data-testid="inLineBlk"
                                className="defaultUnCheck alignCheck inLineBlk"
                                onChange={event =>
                                  this.handleWorkStreamChange(
                                    event,
                                    eachMainWS,
                                    eachWS
                                  )
                                }
                                type="checkbox"
                                checked={this.state.wsSelected.find(function(
                                  val
                                ) {
                                  if (
                                    val.team_id == eachMainWS.team_id ||
                                    eachMainWS.team_name ==
                                      "Shared Workstream" ||
                                    eachMainWS.team_name ==
                                      "Personal Workstream"
                                  ) {
                                    return val.ws.find(value =>
                                      value.id == eachWS.id ? true : false
                                    );
                                  }
                                })}
                                id={"xclude_" + eachWS.id}
                              />
                              <label htmlFor={"xclude_" + eachWS.id} />
                              <div className="inLineBlk alignOdjList">
                                <div className="alignObjInfo truncate">
                                  {eachWS.name}
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>

          { executeModule &&
            <div className="createWs">
              <ThemeProvider>
                <Button
                    className="createWsBtn"
                    kind="normal"
                    onClick={this.CreateNewWs}
                    variant="ghost"
                    startIcon={
                      <i className="createWsImg">
                      </i>}
                >
                  {t('Create new workstream')}
                </Button>
              </ThemeProvider>
            </div>
          }
          {this.state.createWsPopUp && executeModule && (
            <CreateWsPopUp closeWsPopUp={this.closeWsPopUp} />
          )}
          <div
            className="verticalTop inLineBlk startErr"
            data-id={errors["showWsErr"]}
          >
            {typeof errors["showWsErr"] !== "undefined" ? (
              <div className="krstarttargetError"
                role="alert"
                aria-live='polite'
                aria-atomic="true"
                >
                <div className="outline-error_outline-14px-red" />
                <div className="Err-target">{this.state.wsValueErr}</div>
              </div>
            ) : (
              ""
            )}
          </div>

          {this.state.wsSelected.length > 0 && (
            <div className="selectedWsHead">{t('Selected workstream')}(s):</div>
          )}

          <div id="selectedws_wrapper">
          {this.state.wsSelected.length > 0 &&
            this.state.wsListed.map(subWS => (
                  <div className="selectedws" key={subWS.id} id={`selectedws_${subWS.id}`}>
                    <div className="selectedMyAlign selWsHigh">
                      <div className="inLineBlk alignOdjLists">
                        <div className="alignOdjtex" id={`selectedws_label_${subWS.id}`}>{subWS.name}</div>
                        <div className="alignObjInfo">
                        <span>{subWS.mainWS.team_name}</span>{" "}
                        </div>
                      </div>

                      <span className={classes.root}>
                        <ThemeProvider>
                          <StyledIconButton
                            onClick={event =>
                              this.handleWorkStreamChange(event, subWS.mainWS, subWS)
                            }
                            className={classes.closeIconStyle}
                            aria-describedby={`selectedws_label_${subWS.id}`}
                            aria-label='Remove'
                            id={`deleteOptionBtn${subWS.id}`}
                          >
                            <Clear />
                          </StyledIconButton>
                        </ThemeProvider>
                      </span>
                    </div>
                  </div>
                ))
              }
            </div>
          {this.state.columnWsCount > 0 && (
               <Button
                  id="btn-measure-frm-sfc-cln"
                  kind="normal"
                  onClick={event => {
                        this.setState({
                          measureSepWsSearchEn: !this.state.measureSepWsSearchEn,
                          measureColWsEn: !this.state.measureColWsEn
                        },()=>{
                          document.getElementById("btn-measure-frm-sfc-cln").focus();
                        });
                      }}
                  variant={this.state.measureColWsEn ? "ghost" : "tertiary"}
                  className={
                    this.state.measureColWsEn ? "measureBtn" : "measureNotBlueBtn measureBtn"
                  }
                  aria-expanded={this.state.measureColWsEn ? false : true}
                >
                  {t('Measure from specific column')}(s) {t('from custom workstream')}(s){" "}
                  <span className="italicClass">{t('(optional)')}</span>
              </Button>
          )}
          {(this.state.columnWsCount == 1 ||
            this.state.workStreamColSelected.length > 0) &&
            (this.state.measureSepWsSearchEn || !this.state.measureColWsEn) && (
              <div className="wsColumnsSearch">
                <div
                  className="headColWs"
                  onClick={event => {
                    this.getCustomWsFunction(event);
                  }}
                >
                  <div className="searchIconCol icon icon-outline-search-18px"></div>
                  <div className="specificColWsSearchHead">
                    {t('Search for columns within selected workstreams')}
                  </div>
                  <div
                    className="arrowDownIconCol icon icon-dropdown-14px"
                    style={{ verticalAlign: "middle" }}
                  ></div>
                </div>

                {(this.state.columnWsCount == 1 ||
                  this.state.workStreamColSelected.length > 0) &&
                  this.state.measureSepWsEn && (
                    <div id="myAlign" data-testid="myAlign" className="dropdown-alignment ">
                      <input
                        type="text"
                        id="CustomWorkStream"
                        placeholder={t("Search for columns within selected workstreams")}
                        className="specificColWsSearch"
                        onChange={event =>
                          this.changeSearchBox(event, "customWorkstrem")
                        }
                        autoFocus={true}
                        autoComplete="off"
                      />
                      <div className="wsColumnList">
                        {this.state.filter.customWs &&
                          this.state.filter.customWs.map(eachMainWS => (
                            <div>
                              {eachMainWS.ws_name != null && (
                                <div
                                  className="workStreamTitle truncate"
                                  key={`WS${eachMainWS.ws_name}`}
                                >
                                  {eachMainWS.ws_name}
                                </div>
                              )}

                              {eachMainWS.col != null &&
                                eachMainWS.col &&
                                eachMainWS.col.map(eachWS => (
                                  <div className="myAlign" data-testid="myAlign">
                                    <input
                                    data-testid="inLineBlk"
                                      className="defaultUnCheck alignCheck inLineBlk"
                                      onChange={event =>
                                        this.handleWorkStreamColChange(
                                          event,
                                          eachMainWS,
                                          eachWS
                                        )
                                      }
                                      type="checkbox"
                                      defaultChecked={this.state.workStreamColSelected.find(
                                        function(val) {
                                          if (val.id == eachMainWS.id) {
                                            return val.col.find(value =>
                                              value.id == eachWS.id
                                                ? true
                                                : false
                                            );
                                          }
                                        }
                                      )}
                                      id={"xclude_" + eachWS.id}
                                    />
                                    <label htmlFor={"xclude_" + eachWS.id} />
                                    <div className="inLineBlk wsColumnName">
                                      {eachWS.name.length > 40 ? (
                                        <div
                                          className="alignObjInfo truncate"
                                          title={eachWS.name}
                                        >
                                          {eachWS.name}
                                        </div>
                                      ) : (
                                        <div className="alignObjInfo truncate">
                                          {eachWS.name}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                            </div>
                          ))}
                      </div>
                    </div>
                  )}
              </div>
            )}

          {this.state.workStreamColSelected.length > 0 && (
            <div className="selectedColWsHead">
              {t('Selected columns from custom workstream')}(s)
            </div>
          )}

          {this.state.workStreamColSelected.length > 0 &&
            this.state.workStreamColSelected.map(
              MainWS =>
                MainWS.col &&
                MainWS.col.map(subWS => (
                  <div className="selectedws ">
                    <div className="selectedMyAlign selWsHigh">
                      <div className="inLineBlk alignOdjLists">
                        <div className="alignOdjtex">{subWS.name}</div>
                        <div className="alignObjInfo">
                          <span>{MainWS.ws_name}</span>{" "}
                        </div>
                      </div>
                      <div
                        className="outline-close-24px"
                        onClick={event =>
                          this.handleWorkStreamColChange(event, MainWS, subWS)
                        }
                      />
                    </div>
                  </div>
                ))
            )}

          {this.state.workStreamColSelected.length > 0 && (
            <div className="Note-For-progress">
              {'*'+ `${t('Note')}: ${t('For progress workstreams, the whole workstream will be measured.')}`}
            </div>
          )}

          {this.state.wsSelected.length > 0 && (
            <div>
                <div className="Measure-workstream-as">
                  <div className=" inLineBlk verticalTop" id="measure-workstream-title">
                    {t('Measure workstream as')} :
                  </div>
                  <StyledIconButton
                    aria-describedby='measure_workstream-help_tooltip'
                    aria-label='Help'
                    onMouseEnter={event => {this.setState({ achiWsHelpPopUp: true })}}
                    onMouseLeave={event => {this.setState({ achiWsHelpPopUp: false })}}
                    onClick={(e) => this.helpPopperHandler(e)}
                    onKeyDown={(e) => this.helpPopperHandler(e)}
                  >
                    <HelpOutline />
                  </StyledIconButton>
                  {this.state.achiWsHelpPopUp && (
                    <div className="workstream-popup" id="measure_workstream-help_tooltip">
                      <div className="targetHelp">
                        <span className="dot inLineBlk" />
                        <span className="targetHelpDec inLineBlk">
                          <strong>{t('Percentage')} :</strong> {t(`Percentage of "done" action items with a due date within the objective's timeframe`)}
                        </span>
                      </div>
                      <div className="targetHelp">
                        <span className="dot inLineBlk" />
                        <span className="targetHelpDec inLineBlk">
                          <strong>{t('Total')} :</strong> {t(`Number of action items that were due and "done" within the objective's timeframe`)}
                        </span>
                      </div>
                      <div className="targetHelp">
                        <span className="dot inLineBlk" />
                        <span className="targetHelpDec inLineBlk">
                          <strong>{t('Average')} :</strong> {t(`Average number of days it takes to complete action items within the objective's timeframes`)}
                        </span>
                      </div>
                      <div className="targetHelp">
                        <strong>{t('Note')} :</strong> {t(`Action items with a greater level of effort count as a greater percentage of a workstream's progress than actions with a low level of effort.`)}
                      </div>
                    </div>
                  )}
                </div>

                <div role="radiogroup" aria-labelledby='measure-workstream-title'>
                  <div className="wsBoardRadioStd" data-id={this.state.metric}>
                    <div
                      className={this.state.metric == 3 ? "seleced-radio " : "empty-radio"}
                      role="radio"
                      id="radio-percentage"
                      aria-labelledby="label-percentage"
                      onClick={e => this.onSiteChanged(e, 3)}
                      onKeyDown={e => this.radioButtonsKeyboardHandler(e,3)}
                      tabIndex={this.state.metric == 3 ? "0" : "-1"}
                      aria-checked={this.state.metric == 3 ? "true" : "false"}
                    />

                    <label className="wsRadioKr" htmlFor="measure3" id="label-percentage">
                     {t(' Percentage of action items complete')}
                    </label>
                  </div>

                  <div className="wsBoardRadioStd" data-id={this.state.metric}>
                    <div
                      className={this.state.metric == 1 ? "seleced-radio " : "empty-radio"}
                      role="radio"
                      id="radio-total"
                      aria-labelledby="label-total"
                      onClick={e => this.onSiteChanged(e, 1)}
                      onKeyDown={e => this.radioButtonsKeyboardHandler(e,1)}
                      tabIndex={this.state.metric == 1 ? "0" : "-1"}
                      aria-checked={this.state.metric == 1 ? "true" : "false"}
                    />

                    <label className="wsRadioKr" htmlFor="measure1" id="label-total">
                      {t('Total completed action items')}
                    </label>
                  </div>

                  <div className="wsBoardRadioStd" data-id={this.state.metric}>
                    <div
                      className={this.state.metric == 4 ? "seleced-radio " : "empty-radio"}
                      role="radio"
                      id="radio-average"
                      aria-labelledby="label-average"
                      onClick={e => this.onSiteChanged(e, 4)}
                      onKeyDown={e => this.radioButtonsKeyboardHandler(e,4)}
                      tabIndex={this.state.metric == 4 ? "0" : "-1"}
                      aria-checked={this.state.metric == 4 ? "true" : "false"}
                    />

                    <label className="wsRadioKr" htmlFor="measure4" id="label-average">
                      {t('Average cycle time to complete action items')}
                    </label>
                  </div>
                </div>
              {this.state.metric == 4 && (
                <div className="target-cycle-time">
                  <div className="Target-cycle-time-d">
                    {t('Target cycle time (days)')} *
                  </div>
                  <div>
                    <input
                      type="text"
                      className="target-cycle opacity84"
                      name="target"
                      value={this.state.target}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              )}
              <div className="verticalTop inLineBlk">
                {isErrors && typeof errors["showTargetErr"] !== "undefined" ? (
                  <div className="krstarttargetError">
                    <div className="outline-error_outline-14px-red" />
                    <div className="Err-target">
                      {this.state.targetValueErr}
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {(this.props.customData && Object.keys(this.props.customData).length > 0 && !this.props.mitChildKr) && <div className="krBreak" style={{marginBottom:"-10px"}} aria-hidden="true" />}
              {((this.props.addOkrData.groupKRCustomFields|| this.props.groupKRCustomFields) && !this.props.mitChildKr ) &&
                <Customokr
                  customData={this.props.customData}
                  isRequiredCustomOkrFiled={this.isRequiredCustomOkrFiled}
                  onCustomDataChange={(newData) => this.props.onCustomFieldsChange?.(newData)}
                  customFiledRequired={true}
                  renderError={this.renderError}
                  isCustomSave={this.state.isCustomSave}
                />
              }
              {
                !this.props.isChildKr && !this.props.mitChildKr &&
                <div className="krBreak" aria-hidden="true" />
              }
              {!this.props.mitChildKr && <KrRelationshipWrapper {...this.props} metric={this.props.item} saveKr={this.saveKr}/>}
              <AddFinancialTargetsButton objectType="kr" objectId={this.props.item?.id} ownerUserId={this.props.realOwner?.id} />
              {!this.props.mitChildKr && <AddKrTag metric={this.props.item} goalId={this.props.goalDetails.id} taghandler={this.saveTag}
              nplTags={this.state.nplTags}  selectednlplTags={this.state.selectednlplTags} selectednlplTagsName={this.state.selectednlplTagsName} updateTags={this.updateTags} tagsList={this.state.tagsList} searchText={this.props.krText}
              />}
              {
                (this.props.addOkrData.display_nested_kr &&
                !this.props.isChildKr && !this.props.mitChildKr &&
                Math.ceil(moment(this.props.goalDetails.target_date).diff(moment(this.props.goalDetails.start_date), "days", true)) >=  360) &&
                <NestedInlineComp
                {...this.props}
                actions = {this.props.actions}
                nested_krs = {this.props.nested_krs}
                updateNestedKrs = {this.props.updateNestedKrs}
                />
              }
              {
                !this.props.isChildKr && !this.props.mitChildKr &&
                <KrAlignDependance {...this.props}
                saveDependentArr={this.saveDependentArr}
                saveAlignArr={this.saveAlignArr}
                krAlingArr={this.props.item.kr_aligns}
                krDependenciesArr={this.props.item.kr_dependent}
                />
              }
              {
                !this.props.isChildKr && !this.props.mitChildKr &&
                <div className="excludeProgressArea">
                  <StyledCheckbox
                    id='exclude'
                    isChecked={this.state.Exclude ? true : false}
                    label={`${t('Exclude from objective progress calculation')}`}
                    onChange={this.handleExcludeChange}
                    ref={node => (this.dsExcludeProg = node)}
								  />
              </div>
              }

              {!this.state.applyObjKr && !this.props.mitChildKr && (
                <div className="pT10">
                  <div className="viewPermissionArea">
                    <span>
                      {t('View permissions in addition to')}{" "}
                      {this.props.goalDetails.type == 1 ? ` ${t('team')} ` : ` ${t('owner')} `}
                      <div
                        className="metricTargetHelptext permissionHelpText"
                        onMouseEnter={event => {
                          this.setState({ permissionHelpPopUp: true });
                        }}
                        onMouseLeave={event => {
                          this.setState({ permissionHelpPopUp: false });
                        }}
                      />
                      {this.state.permissionHelpPopUp && (
                        <div className="basic-popup">
                          {t(`You can give your whole organization permission to view your Key Result, or just your team and managers`)}
                        </div>
                      )}
                    </span>
                  </div>
                  <div className="pB10">
                    <PermissionComp
                      {...this.props}
                      teamPermissionData={this.teamPermissionData}
                      bizPermissionData={this.bizPermissionData}
                      permissionData={this.permissionData}
                    />
                  </div>
                </div>
              )}
            </div>
          )}

        </div>

    {this.state.confirmPopup && (
      <DeleteCommonModal
        exitDeleteModal={this.exitDeleteModal}
        deleteItems={this.deleteItems}
        id=""
        title={t(this.state.isAnuualQChange ? 'Save Key Result with new duration' : 'Save Key Result with New Data Type')}
        deleteContentOne=""
        deleteContentSecondParam=""
        deletefirstTitle=""
        deleteContentSecond={t(this.state.isAnuualQChange
          ? 'Are you sure you want to change the duration on this Key Result? This will eliminate all Updates and Confidence Flags on the Key Result.'
          : 'Are you sure you want to save this key result with the new data type you selected? This will get rid of past key result data.')}
        buttonText={t(this.state.isAnuualQChange ? 'Change duration' : 'Save')}
      />
    )}
  </form>
  );
  }
}

export default withTranslation()(withStyles(styles)(WorkstreamComp));
